<template>
    <label class="a-checkbox">
        <input
            v-model="localValue"
            type="checkbox"
            class="checkbox-input"
            name="name"
        >
        <div class="checkbox-state">
            <div class="checkbox-control">
                <svg-icon
                    original
                    name="icons/checkbox"
                    class="checkbox-icon"
                />
            </div>
            <div class="checkbox-title">
                {{ label }}
            </div>
        </div>
    </label>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
    name: 'ACheckbox',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        const localValue = computed({
            get: () => props.value,
            set: value => {
                emit('input', value);
            }
        });

        return {
            localValue
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />